import {
  getGlobalErrorsData,
  setGlobalErrors,
  useAppDispatch,
} from '../../store';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
} from '@jobcost-monorepo/ui';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useEffect, useState } from 'react';
import { GLOBAL_ERRORS } from '../../common';
import React from 'react';

const GlobalErrorsModal = () => {
  const dispatch = useAppDispatch();
  const globalErrors = useSelector(getGlobalErrorsData);
  const { t } = useTranslation('errors');
  const [isOpen, setIsOpen] = useState(false);
  const title = t('globalErrors.title');
  const closeLabel = t('globalErrors.close');
  const codeLabel = t('globalErrors.code');
  const descriptionLabel = t('globalErrors.description');
  const messageLabel = t('globalErrors.message');
  const responseMessageLabel = t('globalErrors.responseMessage');

  const handleClose = async () => {
    await dispatch(setGlobalErrors([]));
  };

  useEffect(() => {
    setIsOpen(!(globalErrors?.length === 0));
    console.log(globalErrors);
  }, [globalErrors]);

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent
        onClick={handleClose}
        className="relative transform overflow-hidden rounded-lg border border-gray dark:border-lightGray  bg-white dark:bg-dark px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
      >
        <div className="sm:flex sm:items-start overflow-y-auto">
          <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <DialogTitle className="flex text-red text-base font-semibold leading-6">
              <ExclamationTriangleIcon
                className="h-6 w-6 text-red mr-4"
                aria-hidden="true"
              />
              {title}
            </DialogTitle>
            <div className="mt-2">
              {globalErrors.map((error, index) => (
                <div
                  key={`${GLOBAL_ERRORS}-${index}`}
                  className="mt-3 text-sm font-medium text-gray-500"
                >
                  <div className="flex mb-2">
                    <p className="text-sm font-bold dark:text-slate-50 w-24">
                      {codeLabel}
                    </p>
                    <p className="text-sm dark:text-slate-50 w-full">
                      {error.code}
                    </p>
                  </div>
                  <div className="flex mb-2">
                    <p className="text-sm font-bold dark:text-slate-50 w-24">
                      {descriptionLabel}
                    </p>
                    <p className="text-sm dark:text-slate-50 w-full">
                      {t(`errorCode.${error.code}`)}
                    </p>
                  </div>
                  <div className="flex mb-2">
                    <p className="text-sm font-bold dark:text-slate-50 w-24">
                      {messageLabel}
                    </p>
                    <p className="text-sm dark:text-slate-50 w-full">
                      {error.message}
                    </p>
                  </div>
                  <div className="flex mb-4">
                    <p className="text-sm font-bold dark:text-slate-50 w-24">
                      {responseMessageLabel}
                    </p>
                    <p className="text-sm dark:text-slate-50 w-full">
                      {error.responseMessage}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
          <Button
            type="button"
            className="mt-3 mr-3 inline-flex w-full justify-center rounded-md bg-white  px-3 py-2 text-black shadow-sm border border-black hover:opacity-50 dark:hover:opacity-100 hover:bg-white dark:hover:border-slate-800 sm:mt-0 sm:w-auto"
            onClick={handleClose}
            disabled={false}
          >
            {closeLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default GlobalErrorsModal;
